'use strict';

var _jquery = require('jquery');

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_jquery2.default.fn.dataTable.ext.buttons.clearFilters = {
	name: 'clearFilters',
	className: 'buttons-clear-filters',
	text: function text(dt) {
		return dt.i18n('buttons.clearFilters', '<i class="fa fa-filter" />&nbsp;Clear&nbsp;filters');
	},
	init: function init(dt) {
		var button = this;
		var filtered = anyFilterActive(dt);
		if (!filtered) {
			button.disable();
		}
		(0, _jquery2.default)(dt.table().node()).on('search.dt', function () {
			var filtered = anyFilterActive((0, _jquery2.default)(this).DataTable());
			if (filtered) {
				button.enable();
			} else {
				button.disable();
			}
		});
	},
	action: function action(e, dt) {
		dt.clearFilters();
	}
};

function anyFilterActive(dt) {
	return dt.search() || dt.columns().search().filter(function (x) {
		return x;
	}).length > 0;
}


//////////////////
// WEBPACK FOOTER
// ./~/linksoft/data-tables/buttons/clearFilters.js
// module id = 478
// module chunks = 0